import { conversionUtils } from '@/server-data'

export function convertSpeed(value: number, metric: boolean): number {
  if (!metric) return value
  return Math.round(conversionUtils.convertMilesToKm(value))
}
